import { useState } from "react";
import { FaEarthAmericas } from "react-icons/fa6";
import { IoIosJournal } from "react-icons/io";
import Footer from "./Footer";
import { CiChat1 } from "react-icons/ci";
import { CiBitcoin } from "react-icons/ci";
import { RiMentalHealthLine } from "react-icons/ri";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import {
  MdOutlineBook,
  MdOutlinePeople,
  MdOutlineFoodBank,
} from "react-icons/md";
import ImageCarousel from "./ImageCarousel";

const ProjectsPage = () => {
  const [carouselOpen, setCarouselOpen] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleImageClick = (e, projectIndex, imageIndex) => {
    e.preventDefault();
    e.stopPropagation();
    setCarouselOpen(projectIndex);
    setSelectedImageIndex(imageIndex);
  };

  const handleCloseCarousel = () => {
    setCarouselOpen(null);
    setSelectedImageIndex(0);
  };

  const projects = [
    {
      title: "Microservices Ecommerce Platform",
      description:
        "Architected distributed e-commerce system with 2+ microservices using Java Spring Boot and Docker, deployed on AWS ECS with VPC isolation, Application Load Balancer for traffic distribution, and RDS for data persistence. Implemented event-driven architecture using Apache Kafka and gRPC, reducing service coupling.",
      tags: ["Java", "Springboot", "AWS", "Docker", "Microservices", "Kafka"],
      images: [],
      website: "https://ace-my-interview-ami.vercel.app/",
      github: "https://github.com/alifhakimiazwan/AceMyInterview",
    },
    {
      title: "Ace My Interview",
      description:
        "Ace My Interview is an AI-driven platform designed to help job seekers practice and excel in interviews. Using natural language processing (NLP) and voice interaction, it simulates real interview scenarios by asking role-specific questions and evaluating verbal responses.",
      tags: ["NextJS", "AI Agents", "Typescript"],
      images: ["/assets/ami1.png", "/assets/ami2.png", "/assets/ami3.png"],
      website: "https://ace-my-interview-ami.vercel.app/",
      github: "https://github.com/alifhakimiazwan/AceMyInterview",
    },
    {
      title: "Chat With PDF",
      description:
        "Developed a study tool that leverages NLP for interactive Q&A with PDF documents. Implemented text extraction, context-aware querying, and dynamic response generation.",
      tags: ["NextJS", "LLM", "PostgreSQL"],
      images: ["/assets/cwp1.png", "/assets/cwp2.png", "/assets/cwp3.png"],
      github: "https://github.com/alifhakimiazwan/Chat-With-PDF",
      website: null,
    },
    {
      title: "Rate My University",
      description:
        "Developed a elective subject rating platform for UKM students, using NextJS, React, and MongoDB, enabling students to explore and rate elective subjects. Built an intuitive search and filtering system, allowing users to sort subjects by difficulty, popularity, and mode of study, leading to 500+ visitors and 100+ reviews. Implemented S3 buckets for user image uploads and deployed the service.",
      tags: ["NextJS", "MongoDB", "AWS S3"],
      images: ["/assets/rmc1.png", "/assets/rmc2.png", "/assets/rmc3.png"],
      website: "https://ratemyuni.my/",
      github: "https://github.com/alifhakimiazwan/RateMyUniversity",
    },
    {
      title: "Premier League Match Predictor",
      description:
        "Developed a Premier League match predictor using Python, Scikit-learn, and machine learning techniques, primarily focusing on decision trees. The project involved data cleaning, feature engineering, and model training to predict match outcomes based on historical data.",
      tags: ["Python", "Machine Learning", "Scikit"],
      images: [],
      github:
        "https://github.com/alifhakimiazwan/Premier-League-Match-Predictor",
      website: null,
    },
    {
      title: "Ebay Price Tracker",
      description:
        "Tracks and compares prices on Ebay using Python and web scraping.",
      tags: ["Python", "Numpy", "Web Scraping"],
      images: [],
      github: "https://github.com/sms021019/mental-health-tracker",
      website: null,
    },
  ];

  return (
    <div className="mt-10 flex flex-col items-center px-4">
      <h1 className="text-3xl sm:text-4xl md:text-5xl">Projects</h1>
      <div className="mt-4 space-y-6 w-full">
        {projects.map((project, index) => (
          <a
            key={index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <div className="flex flex-col p-4 sm:p-6 bg-gray-50 rounded-3xl shadow-md hover:scale-105 duration-300 cursor-pointer">
              <div className="flex-1">
                <h3 className="text-xl sm:text-2xl font-medium">
                  {project.title}
                </h3>
                <p className="mt-2 font-light text-xs sm:text-sm opacity-75">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mt-2">
                  {project.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="text-xs sm:text-sm py-1 px-2 sm:px-3 bg-gray-200 rounded-3xl"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-3 sm:mt-4">
                  {project.images.map((image, imgIndex) => (
                    <img
                      key={imgIndex}
                      src={image}
                      alt={`${project.title} ${imgIndex + 1}`}
                      className="rounded-lg w-full cursor-pointer hover:opacity-80 transition-opacity duration-200"
                      onClick={(e) => handleImageClick(e, index, imgIndex)}
                    />
                  ))}
                </div>
                <div className="flex flex-wrap gap-3 sm:gap-4 mt-3">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-1 text-xs sm:text-sm text-blue-600 hover:underline"
                  >
                    <FaGithub />
                    <span>View GitHub</span>
                  </a>
                  {project.website && (
                    <a
                      href={project.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center space-x-1 text-xs sm:text-sm text-blue-600 hover:underline"
                    >
                      <FaExternalLinkAlt />
                      <span>View Website</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* Carousel Modal */}
      {carouselOpen !== null && projects[carouselOpen].images.length > 0 && (
        <ImageCarousel
          images={projects[carouselOpen].images}
          initialIndex={selectedImageIndex}
          onClose={handleCloseCarousel}
          projectTitle={projects[carouselOpen].title}
        />
      )}

      <Footer />
    </div>
  );
};

export default ProjectsPage;
